/*
 * Copyright '2022-2023' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { ActionTypeModel } from "./action-type.model";

export interface ServicePageNotification {
  id: string;
  location: string;
  severity: string;
  startDate?: any;
  endDate?: any;
  localeToMessage: { [key: string]: string };
  dismissible?: boolean;
  messageData?: MessageData;
  action?: ActionTypeModel;
}

export enum ServicePageNotificationsType {
  ERROR = "ERROR",
  WARNING = "WARNING",
  INFORMATIONAL = "INFORMATIONAL",
}

export enum AlertType {
  GSI = "GSI",
  GAU = "GAU",
}

export interface MessageData {
  eventStartDate?: any;
  eventEndDate?: any;
  service?: string;
}
